import { useEffect, useState } from 'react';

import { fetchLaunchAccess } from '../config/launchAccess';

export default function useLaunchAccess() {
  const [state, setState] = useState({
    loading: true,
    canSignUp: false,
    selectedMarket: null,
  });

  useEffect(() => {
    let cancelled = false;

    fetchLaunchAccess()
      .then((access) => {
        if (cancelled) return;
        setState({
          loading: false,
          canSignUp: access.canSignUp,
          selectedMarket: access.selectedMarket,
        });
      })
      .catch(() => {
        if (cancelled) return;
        // Fail closed: waitlist only until we know the city is live.
        setState({ loading: false, canSignUp: false, selectedMarket: null });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
